import { render, staticRenderFns } from "./DashboardCxP.vue?vue&type=template&id=285504cc&scoped=true"
import script from "./DashboardCxP.vue?vue&type=script&lang=js"
export * from "./DashboardCxP.vue?vue&type=script&lang=js"
import style0 from "./DashboardCxP.vue?vue&type=style&index=0&id=285504cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285504cc",
  null
  
)

export default component.exports